"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Maintenance;
const constants_1 = require("core/constants");
const React = __importStar(require("react"));
function Maintenance() {
    return (React.createElement("div", null,
        React.createElement("div", { className: "u-flex u-flexCol u-flexJustifyCenter u-flexAlignSelfCenter u-flexAlignContentCenter u-padLg" },
            React.createElement("p", { className: "u-flexAlignSelfCenter" },
                React.createElement("svg", { viewBox: "0 0 960 960", role: "presentation", height: "5em", width: "5em", fill: "#FF8F00" },
                    React.createElement("path", { d: "M948 823c8 11.3 12 23.7 12 37 0 18-6.3 33.2-19 45.5S913.3 924 896 924H64c-23.3 0-41.7-10.3-55-31-12.7-20-13-41-1-63L424 61c12-22 30.7-33 56-33s44 11 56 33l412 762zM478 610h3c9.3 0 18-3.8 26-11.5s12.7-16.5 14-26.5c8-43.3 18.7-126.3 32-249 .7-8.7-1.8-17-7.5-25s-13.2-13-22.5-15c-28-5.3-56.3-5.3-85 0-8.7 2-16.2 7-22.5 15s-9.2 16.3-8.5 25c13.3 122.7 24 205.7 32 249 1.3 10 6 18.8 14 26.5s16.3 11.5 25 11.5zm2 227c20 0 37-7 51-21s21-31 21-51-7-37-21-51-31-21-51-21-37 7-51 21-21 31-21 51 7 37 21 51 31 21 51 21z" }))),
            React.createElement("h1", { className: "u-flexAlignSelfCenter u-textCenter" }, "This page is undergoing brief maintenance."),
            React.createElement("h3", { className: "u-flexAlignSelfCenter u-textCenter" }, "Please softly hum elevator music to yourself, and then try again later."),
            React.createElement("a", { href: `${constants_1.TEAMSNAP_URL}/team/dashboard`, className: "u-flexAlignSelfCenter" }, "Go back to my teams"))));
}
